<template>
  <div>
    <o-medium-title :center="true">{{$t('reservas.resumenAlquiler.resumen')}}</o-medium-title>
    <v-layout wrap justify-center>
      <v-flex xs12 xl3>
        <o-thin-title :center="true">
          {{$t('reservas.resumenAlquiler.pagosGenerales')}}
        </o-thin-title>
        <o-base-center-text>
          <strong>{{$t('reservas.resumenAlquiler.reserva')}}{{reservaTotalAlquiler | currency}}</strong>
        </o-base-center-text>
        <o-base-center-text>
          <strong>{{$t('reservas.resumenAlquiler.fianza')}}{{fianzaTotalAlquiler | currency}}</strong>
        </o-base-center-text>
        <o-base-center-text v-if="provisionTotalAlquiler > 0">
          <strong>{{$t('reservas.resumenAlquiler.provision')}}{{provisionTotalAlquiler | currency}}</strong>
        </o-base-center-text>
        <o-base-center-text v-if="importeGarantiaTotalAlquiler > 0">
          <strong>{{$t('reservas.resumenAlquiler.garantia')}}{{importeGarantiaTotalAlquiler | currency}}</strong>
        </o-base-center-text>
        <o-base-center-text v-if="pagosRecurrentes.length <= 1">
          <strong>{{$t('reservas.resumenAlquiler.renta', {periodo: periodo, tarifa: $options.filters['currency'](tarifa.importeAlquiler), textoIva})}}</strong>
        </o-base-center-text>
      </v-flex>
      <v-flex xs12 xl9 v-if="pagosRecurrentes.length > 1">
        <v-layout row fill-height>
          <v-flex class="hidden-md-and-down" mb-3 mx-2 shrink>
            <v-divider vertical/>
          </v-flex>
          <v-layout column>
            <o-thin-title center noPadding>
              {{$t('reservas.resumenAlquiler.pagosRecurrentes')}}
            </o-thin-title>
            <v-layout row>
              <v-flex xs12 mb-3>
                <v-data-table
                  :headers="headers"
                  :items="pagosRecurrentes"
                  hide-actions
                >
                  <template #headerCell="props">
                    <span style="white-space: pre-line">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <template slot="items" slot-scope="props" >
                    <tr>
                      <td class="text-xs-left" style="min-width:200px;width:100%;" v-if="mostrarColumnaInmueble">
                        {{props.item.inmueble}}
                      </td>
                      <td :class="{
                          'text-xs-left': !mostrarColumnaInmueble,
                          'text-xs-center': mostrarColumnaInmueble,
                          tableSmallPadding: mostrarColumnaInmueble
                        }"
                      >
                        {{props.item.concepto}}
                      </td>
                      <td class="text-xs-center tableSmallPadding">
                        {{props.item.firmaContratoVar === 'S' ? $t('reservas.resumenAlquiler.pagoUnico') : props.item.periodicidad}}
                      </td>
                      <td class="text-xs-center tableSmallPadding">
                        {{props.item.importe | currency}}
                      </td>
                      <td class="text-xs-center tableSmallPadding">
                        {{props.item.iva | decimalInput}} %
                      </td>
                      <td class="text-xs-center tableSmallPadding">
                        {{props.item.importeIva | currency}}
                      </td>
                      <td class="text-xs-center">
                        {{props.item.firmaContrato}}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    incrustado: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      promocion: 'promociones/getActual',
      tarifaInmueble: 'promociones/inmuebles/tarifas/getActual',
      aplazadosStore: 'promociones/inmuebles/tarifas/aplazados/getAll',
      reservaActual: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll',
      politicaPrivacidad: 'configuracion/politicaPrivacidad/get',
      tarifaReserva: 'reservas/_id/tarifas/getActual',
      tarifaReservaHijas: 'reservas/_id/tarifas/getHijas',
      tarifaHijaByCodigoActivo: 'reservas/_id/tarifas/getByCodigoActivo'
    }),
    headers () {
      let headers = [
        {
          text: this.$t('reservas.resumenAlquiler.inmueble'),
          align: 'left',
          value: 'inmueble',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.concepto'),
          align: this.mostrarColumnaInmueble ? 'center' : 'left',
          value: 'concepto',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.periocidadMeses'),
          align: 'center',
          value: 'periodicidad',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.importe'),
          align: 'center',
          value: 'importe',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.porcentajeImpuesto'),
          align: 'center',
          value: 'iva',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.importeImpuesto'),
          align: 'center',
          value: 'importeIva',
          sortable: false,
          class: 'pt-0'
        },
        {
          text: this.$t('reservas.resumenAlquiler.firmaContrato'),
          align: 'center',
          value: 'firmaContrato',
          sortable: false,
          class: 'pt-0'
        }
      ]
      if (!this.mostrarColumnaInmueble) {
        headers.shift()
      }
      return headers
    },
    mostrarColumnaInmueble () {
      let tarifasHijas = null
      if (this.incrustado) {
        tarifasHijas = this.inmueble.inmueblesHijos.map(x => x.tarifaAlquiler)
      } else {
        tarifasHijas = this.tarifaReservaHijas
      }
      return tarifasHijas.length > 0
    },
    tarifa () {
      if (this.incrustado) {
        return this.tarifaInmueble
      } else {
        return this.tarifaReserva
      }
    },
    pagosRecurrentes () {
      let retorno = []
      const conceptoPrincipal = {
        inmueble: this.inmueble.descripcionLarga,
        concepto: this.$t('reservas.resumenAlquiler.alquiler'),
        periodicidad: this.tarifa.periodicidadAlquiler,
        importe: this.tarifa.importeAlquiler,
        iva: this.tarifa.ivaAlquiler,
        importeIva: this.tarifa.importeAlquiler / 100 * this.tarifa.ivaAlquiler,
        firmaContratoVar: 'N',
        firmaContrato: 'No'
      }
      // Añadimos conceptos del inmueble principal
      retorno = retorno.concat(this.tarifa.conceptos.map(x => ({
        inmueble: this.inmueble.descripcionLarga,
        concepto: x.concepto.descripcion,
        periodicidad: x.periodo,
        importe: x.importe,
        iva: x.iva,
        importeIva: x.importeIVA,
        firmaContratoVar: x.firmaContrato,
        firmaContrato: x.firmaContrato === 'S' ? this.$t('reservas.resumenAlquiler.si') : this.$t('reservas.resumenAlquiler.no')
      }))).sort((x, y) => (x.concepto).localeCompare(y.concepto))

      // por cada hijo añadimos su alquler y luego sus conceptos
      this.inmueble.inmueblesHijos.forEach(hijo => {
        let conceptosHijo = []
        let tarifaHija = this.incrustado ? hijo.tarifaAlquiler : this.tarifaHijaByCodigoActivo(hijo.codigoActivo)
        if (tarifaHija != null && tarifaHija.importeAlquiler > 0) {
          conceptosHijo.push(
            {
              inmueble: hijo.descripcionLarga,
              concepto: this.$t('reservas.resumenAlquiler.alquiler'),
              periodicidad: tarifaHija.periodicidadAlquiler,
              importe: tarifaHija.importeAlquiler,
              iva: tarifaHija.ivaAlquiler,
              importeIva: tarifaHija.importeAlquiler / 100 * tarifaHija.ivaAlquiler,
              firmaContratoVar: 'N',
              firmaContrato: 'No'
            }
          )
        }
        if (tarifaHija != null) {
          conceptosHijo = conceptosHijo.concat(tarifaHija.conceptos.map(x => ({
            inmueble: hijo.descripcionLarga,
            concepto: x.concepto.descripcion,
            periodicidad: x.periodo,
            importe: x.importe,
            iva: x.iva,
            importeIva: x.importeIVA,
            firmaContratoVar: x.firmaContrato,
            firmaContrato: x.firmaContrato === 'S' ? this.$t('reservas.formularioFisico.si') : this.$t('reservas.formularioFisico.no')
          }))).sort((x, y) => (x.concepto).localeCompare(y.concepto)) // ordenar por concepto
        }
        retorno = retorno.concat(conceptosHijo)
      })
      if (retorno.length > 0) {
        retorno = [conceptoPrincipal].concat(retorno)
      }
      return retorno
    },
    // miramos si el iva es null
    textoIva () {
      return this.tarifa.ivaAlquiler == null ? '' : ' (+' + this.$options.filters['decimalInput'](this.tarifa.ivaAlquiler) + '% IVA)'
    },
    reservaTotalAlquiler () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifaAlquiler != null) {
            total += Number(hijo.tarifaAlquiler.importeReserva)
          }
        }
        total += Number(this.tarifa.importeReserva)
        return total
      } else {
        return this.reservaActual.importeReserva
      }
    },
    fianzaTotalAlquiler () {
      let total = 0
      let tarifasHijas = null
      if (this.incrustado) {
        tarifasHijas = this.inmueble.inmueblesHijos.map(x => x.tarifaAlquiler)
      } else {
        tarifasHijas = this.tarifaReservaHijas
      }
      for (let tarifaHija of tarifasHijas) {
        if (tarifaHija != null) {
          total += Number(tarifaHija.importeFianza)
        }
      }
      total += Number(this.tarifa.importeFianza)
      return total
    },
    provisionTotalAlquiler () {
      let total = 0
      let tarifasHijas = null
      if (this.incrustado) {
        tarifasHijas = this.inmueble.inmueblesHijos.map(x => x.tarifaAlquiler)
      } else {
        tarifasHijas = this.tarifaReservaHijas
      }
      for (let tarifaHija of tarifasHijas) {
        if (tarifaHija != null && tarifaHija.importeProvision != null) {
          total += Number(tarifaHija.importeProvision)
        }
      }
      if (this.tarifa.importeProvision != null) {
        total += Number(this.tarifa.importeProvision)
      }
      return total
    },
    importeGarantiaTotalAlquiler () {
      let total = 0
      let tarifasHijas = null
      if (this.incrustado) {
        tarifasHijas = this.inmueble.inmueblesHijos.map(x => x.tarifaAlquiler)
      } else {
        tarifasHijas = this.tarifaReservaHijas
      }
      for (let tarifaHija of tarifasHijas) {
        if (tarifaHija != null && tarifaHija.importeGarantia != null) {
          total += Number(tarifaHija.importeGarantia)
        }
      }
      if (this.tarifa.importeGarantia != null) {
        total += Number(this.tarifa.importeGarantia)
      }
      return total
    },
    periodo () {
      switch (this.tarifa.periodicidadAlquiler) {
        case 1:
          return this.$t('reservas.resumenAlquiler.mensual')
        case 2:
          return this.$t('reservas.resumenAlquiler.biMensual')
        case 3:
          return this.$t('reservas.resumenAlquiler.trimestral')
        case 6:
          return this.$t('reservas.resumenAlquiler.semestral')
        case 12:
          return this.$t('reservas.resumenAlquiler.anual')
        default:
          return this.$t('reservas.resumenAlquiler.cadaXMeses', {tarifa: this.tarifa.periodicidadAlquiler})
      }
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/condiciones/ResumenAlquiler.vue